import type { ReactNode } from 'react';

export const symbol_functions: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M515-480 250-728q-4.62-4.7-7.31-10.57-2.69-5.86-2.69-12.13v-18q0-13.3 8.91-22.3 8.92-9 22.09-9h399q20.83 0 35.42 14.62Q720-770.76 720-749.88q0 20.88-14.58 35.38Q690.83-700 670-700H396l212 198q10 9.13 10 22.07Q618-467 608-458L396-260h274q20.83 0 35.42 14.62Q720-230.76 720-209.88q0 20.88-14.58 35.38Q690.83-160 670-160H263q-9.52 0-16.26-6.72-6.74-6.73-6.74-16.22V-213q0-4.94 1.5-9.47T247-230l268-250Z"
		/>
	</svg>
);
